import { CircularProgress, Grid } from '@mui/material';

import api from '~/api/Endpoints';
import { useQuery } from '~/hooks/useQuery';
import { useUser } from '~/hooks/useUser';
import { useHandleException } from '~/scripts/handleException';
import { ApiPricingCard } from './ApiPricingCard';

export const ApiPlans = () => {
  const user = useUser();
  const handleException = useHandleException();
  const getApiPlansQuery = useQuery({
    queryKey: [user?.uuid],
    queryFn: async () => {
      return api.get(`/api-access/plans`);
    },
    onError(error) {
      handleException(error, { category: 'api-plans' });
    },
  });

  return (
    <>
      {getApiPlansQuery.isLoading && (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      )}
      {getApiPlansQuery.data?.map((plan) => {
        return (
          <Grid item lg={4} md={12} sm={12} key={plan.id}>
            <ApiPricingCard
              title={plan.nickname!}
              description={plan.metadata?.description || ''}
              tiers={plan.tiers!}
            />
          </Grid>
        );
      })}
    </>
  );
};
